import React, { useState, useEffect } from 'react'
import { X } from 'lucide-react'
import './styles.scss'

export default function ProgramModal({ isOpen, onClose, onSave, initialData, isSuperAdmin }) {
  const [formData, setFormData] = useState({
    name: '',
    degreeLevel: 'Undergraduate',
    department: '',
    deliveryMode: 'On Campus',
    locked: false
  })

  useEffect(() => {
    if (initialData && isOpen) {
      setFormData(initialData)
    } else if (isOpen) {
      setFormData({
        name: '',
        degreeLevel: 'Undergraduate',
        department: '',
        deliveryMode: 'On Campus',
        locked: false
      })
    }
  }, [initialData, isOpen])

  if (!isOpen) return null

  const handleSubmit = (e) => {
    e.preventDefault()
    onSave({ ...formData, active: true })
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content fade-in">
        <div className="modal-header">
          <h2>{initialData ? 'Edit Program' : 'Add New Program'}</h2>
          <button className="icon-btn" onClick={onClose}><X size={20} /></button>
        </div>
        
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label>Program Name</label>
            <input 
              type="text" 
              required
              placeholder="e.g. MS Computer Science"
              value={formData.name}
              onChange={e => setFormData({...formData, name: e.target.value})}
            />
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label>Degree Level</label>
              <select 
                value={formData.degreeLevel}
                onChange={e => setFormData({...formData, degreeLevel: e.target.value})}
              >
                <option value="Undergraduate">Undergraduate</option>
                <option value="Graduate">Graduate</option>
                <option value="IEI">IEI (English Language)</option>
                <option value="PhD">PhD</option>
              </select>
            </div>
            <div className="form-group">
              <label>Delivery Mode</label>
              <select 
                value={formData.deliveryMode}
                onChange={e => setFormData({...formData, deliveryMode: e.target.value})}
              >
                <option value="On Campus">On Campus</option>
                <option value="Online">Online</option>
                <option value="Hybrid">Hybrid</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Department</label>
            <input 
              type="text" 
              placeholder="e.g. College of Engineering"
              value={formData.department}
              onChange={e => setFormData({...formData, department: e.target.value})}
            />
          </div>

          {isSuperAdmin && (
            <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '1rem' }}>
              <input 
                type="checkbox" 
                id="lockProgram"
                style={{ width: '18px', height: '18px' }}
                checked={formData.locked}
                onChange={e => setFormData({...formData, locked: e.target.checked})}
              />
              <label htmlFor="lockProgram" style={{ margin: 0, color: '#dc2626' }}>
                Lock Program (Prevents other Admins from editing)
              </label>
            </div>
          )}

          <div className="modal-actions">
            <button type="button" className="btn btn-outline" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary">{initialData ? 'Save Changes' : 'Create Program'}</button>
          </div>
        </form>
      </div>
    </div>
  )
}
